import { convertUpperCamelCase, exists, tsValidateDynamicObject, tsValidateMustExist, tsValidateNumber, tsValidateResult, tsValidateString } from '@nu-art/ts-common';
import { PushPubSubDBGroup } from '../shared.js';
const Validator_FilterKey = (value) => {
    if (typeof value === 'string')
        return tsValidateResult(value, tsValidateString());
    if (typeof value === 'number')
        return tsValidateResult(value, tsValidateNumber());
    if (exists(value))
        return `expected type number | string but received ${typeof value}`;
    return tsValidateResult(value, tsValidateMustExist);
};
const Validator_ModifiableProps = {
    pushSessionId: tsValidateString(),
    filter: tsValidateDynamicObject(Validator_FilterKey, tsValidateString(), false),
    topic: tsValidateString(200)
};
const Validator_GeneratedProps = {
//
};
export const DBDef_PushSubscription = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'push-subscription',
    entityName: convertUpperCamelCase('PushSubscription', '-').toLowerCase(),
    frontend: {
        group: PushPubSubDBGroup,
        name: 'subscription',
    },
    backend: {
        name: 'push-subscription'
    }
};
//# sourceMappingURL=db-def.js.map